import React, { useContext } from "react";
import { CartContext } from "../Component/CartContext";
import productData from "../Datas/productData";
import "../css/cartpage.scss";
import { Link, useNavigate } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";

const CartPage = () => {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity } = useContext(CartContext);
  const [giftMessage, setGiftMessage] = React.useState("");

  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  const calculateTotal = () => {
    let total = 0;
    cartItems.forEach((item) => {
      const product = getProductById(item.id);
      if (product) {
        const price = parseFloat(product.price.replace(/,/g, ""));
        total += price * item.quantity;
      }
    });
    return total;
  };

  const subtotal = calculateTotal();

  const handleUpdateQuantity = (id, size, newQuantity) => {
    if (newQuantity > 0) {
      updateQuantity(id, size, newQuantity);
    }
  };

  const handleCheckout = () => {
    if (cartItems.length > 0) {
      navigate("/checkout");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      alert("Your cart is empty");
    }
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (cartItems.length === 0) {
    return (
      <div className="cart-page">
        <Header />
        <div className="cart-page__empty">
          <h2>Your cart is empty</h2>
          <p>Explore our collection of fine teas and ceramics!</p>
          <Link to="/shop" onClick={toTop} className="cart-page__continue-btn">
            Continue shopping
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  const shippingThreshold = 249;
  const isFreeShipping = subtotal >= shippingThreshold;
  const shippingCost = isFreeShipping ? 0 : 25;

  return (
    <div className="cart-page">
      <Header />

      <main className="cart-page__main">
        {/* 购物车进度指示器 */}
        <div className="cart-progress">
          <div className="cart-progress__container">
            <div className="progress-steps">
              <div className="progress-step active">
                <span className="step-text">SHOPPING CART</span>
              </div>
              <div className="progress-arrow">›</div>
              <div className="progress-step">
                <span className="step-text">CHECKOUT DETAILS</span>
              </div>
              <div className="progress-arrow">›</div>
              <div className="progress-step">
                <span className="step-text">ORDER COMPLETE</span>
              </div>
            </div>
          </div>
        </div>

        <div className="cart-page__container">
          <div className="cart-page__content">
            {/* 购物车商品列表 */}
            <div className="cart-items">
              <div className="cart-header">
                <div className="cart-header__product">PRODUCT</div>
                <div className="cart-header__price">PRICE</div>
                <div className="cart-header__quantity">QUANTITY</div>
                <div className="cart-header__subtotal">SUBTOTAL</div>
              </div>

              <div className="cart-items-list">
                {cartItems.map((item) => {
                  const product = getProductById(item.id);
                  if (!product) return null;

                  const itemPrice = parseFloat(product.price.replace(/,/g, ""));
                  const itemSubtotal = itemPrice * item.quantity;

                  return (
                    <div
                      key={`${item.id}-${item.size || "default"}`}
                      className="cart-item"
                    >
                      {/* 删除按钮 */}
                      <button
                        className="cart-item__remove"
                        onClick={() => removeFromCart(item.id, item.size)}
                        title="Remove item"
                      >
                        ×
                      </button>

                      {/* 产品信息 */}
                      <div className="cart-item__product">
                        <div className="cart-item__image">
                          <img
                            src={product.images[0]}
                            alt={product.name}
                            className="cart-item__img"
                          />
                        </div>
                        <div className="cart-item__info">
                          <h3 className="cart-item__name">{product.name}</h3>
                          {item.size && (
                            <p className="cart-item__size">Size: {item.size}</p>
                          )}
                        </div>
                      </div>

                      {/* 价格 */}
                      <div className="cart-item__price">${product.price}</div>

                      {/* 数量控制 */}
                      <div className="cart-item__quantity">
                        <div className="quantity-controls">
                          <button
                            className="quantity-btn quantity-btn--minus"
                            onClick={() =>
                              handleUpdateQuantity(
                                item.id,
                                item.size,
                                item.quantity - 1
                              )
                            }
                          >
                            -
                          </button>
                          <input
                            type="number"
                            value={item.quantity}
                            onChange={(e) =>
                              handleUpdateQuantity(
                                item.id,
                                item.size,
                                parseInt(e.target.value) || 1
                              )
                            }
                            className="quantity-input"
                            min="1"
                          />
                          <button
                            className="quantity-btn quantity-btn--plus"
                            onClick={() =>
                              handleUpdateQuantity(
                                item.id,
                                item.size,
                                item.quantity + 1
                              )
                            }
                          >
                            +
                          </button>
                        </div>
                      </div>

                      {/* 小计 */}
                      <div className="cart-item__subtotal">
                        ${itemSubtotal.toFixed(2)}
                      </div>
                    </div>
                  );
                })}
              </div>

              {/* 继续购物按钮 */}
              <div className="cart-actions">
                <Link
                  to="/shop"
                  onClick={toTop}
                  className="continue-shopping-btn"
                >
                  ← CONTINUE SHOPPING
                </Link>
              </div>
            </div>

            {/* 购物车总计 */}
            <div className="cart-totals">
              <h3 className="cart-totals__title">CART TOTALS</h3>

              <div className="cart-totals__content">
                <div className="total-row">
                  <span className="total-label">Subtotal</span>
                  <span className="total-value">${subtotal.toFixed(2)}</span>
                </div>

                <div className="total-row shipping-row">
                  <span className="total-label">Shipping</span>
                  <div className="shipping-info">
                    <div className="shipping-rate">
                      Flat rate: ${shippingCost.toFixed(2)}
                    </div>
                    <button className="calculate-shipping-btn">
                      Calculate shipping
                    </button>
                  </div>
                </div>

                <div className="total-row total-final">
                  <span className="total-label">Total</span>
                  <span className="total-value">
                    ${(subtotal + shippingCost).toFixed(2)}
                  </span>
                </div>

                <button
                  className="proceed-checkout-btn"
                  onClick={handleCheckout}
                >
                  PROCEED TO CHECKOUT
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default CartPage;
